import { basename } from "../utils/Url";
import { ApiList, ApiObject } from "../utils/Api";
import { defaultApiBuilder, defaultApiWithCustomUrlBuilder } from "../utils/axios/apiBuilder";
import { parseJSON } from "../utils/date";
import { getOrderQueryDirection } from "../utils/ordering";

const apiPosition = defaultApiBuilder(parseJSON);
const apiPositionList = defaultApiBuilder(ApiList);
const apiPositionObject = defaultApiBuilder(ApiObject);

export const AxiosPositionsAPI = {
  createPosition: async data => {
    const response = await apiPosition.post(
      "/positions/create_complete/",
      data
    );
    return response.data;
  },
  editPosition: async data => {
    const response = await apiPosition.patch(
      `/positions/${data.id}/edit_position_and_record/`,
      data
    );
    return response.data;
  },
  getRecords: async (position_id, ordering = null) => {
    const params = {
      position: position_id
    };
    if (ordering) params.ordering = getOrderQueryDirection(ordering);

    const response = await apiPosition.get(`/position_records/`, { params });
    return response.data;
  },
  getAll: async (
    { active = true, search = "", page = 1 },
    { signal }
  ) => {
    const params = {
      expand: ['_extra', '_links.record_set'].join(','),
      active,
      page
    };
    if (search) params.search = search;

    const response = await apiPositionList.get(`/positions/`, { params, signal });
    return response.data;
  },
  getById: async ({ position_id }, { signal }) => {
    const params = {
      expand: ['_extra', '_links.record_set'].join(',')
    };

    const response = await apiPositionObject.get(
      `/positions/${position_id}/`,
      { params, signal}
    );
    return response.data;
  },
  getSeniorityLevels: async ({ signal }) => {
    const response = await apiPositionList.get('/seniority_levels/', { signal });
    return response.data;
  }
};
